import createMetadataAPISelectors from '../../utils/api-metadata-selectors';

const options = {
  name: 'incidentFairnessPenaltyOverrides',
  baseType: 'INCIDENT_FAIRNESS_PENALTY_OVERRIDES',
  apiEndpoint: 'incident_fairness_penalty_overrides'
};

const metadataApiSelectors = createMetadataAPISelectors(options);

const overridesByMembershipAndSkillId = state => state.incidentFairnessPenaltyOverrides.byMembershipAndSkillId;

export default {
  ...metadataApiSelectors,
  overridesByMembershipAndSkillId
};
